export default __webpack_public_path__ + "static/form-button-feedback-dont-738834455ce4d3357da66a98de6c5cb381dc4edd89c013cd722ca28d9e4976d0.png";